import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './style.scss';

const isActive = (selectedSortOption, option) => selectedSortOption === option;

const handleClick = (option, getXpacks) =>
  getXpacks({
    page: 1,
    ordering: option,
  });

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

const XpackSort = ({ getXpacks, selectedSortOption }) => (
  <div styleName="xpack__sort">
    <div styleName="xpack__sort__item">
      <span>xPack name</span>
      <div styleName="xpack__sort__arrows">
        <span
          styleName={classnames({
            'is-active': isActive(selectedSortOption, 'name'),
          })}
          className="icon-triangle-arrow-up"
          onClick={() => handleClick('name', getXpacks)}
          data-test="sort-xpack-by-name-ascending"
        />

        <span
          styleName={classnames({
            'is-active': isActive(selectedSortOption, '-name'),
          })}
          className="icon-triangle-arrow-down"
          onClick={() => handleClick('-name', getXpacks)}
          data-test="sort-xpack-by-name-descending"
        />
      </div>
    </div>

    <div styleName="xpack__sort__item">
      <span>Created on</span>
      <div styleName="xpack__sort__arrows">
        <span
          styleName={classnames({
            'is-active': isActive(selectedSortOption, 'created_at'),
          })}
          className="icon-triangle-arrow-up"
          onClick={() => handleClick('created_at', getXpacks)}
          data-test="sort-xpack-by-date-ascending"
        />

        <span
          styleName={classnames({
            'is-active': isActive(selectedSortOption, '-created_at'),
          })}
          className="icon-triangle-arrow-down"
          onClick={() => handleClick('-created_at', getXpacks)}
          data-test="sort-xpack-by-date-descending"
        />
      </div>
    </div>
  </div>
);

XpackSort.propTypes = {
  getXpacks: PropTypes.func.isRequired,
  selectedSortOption: PropTypes.string.isRequired,
};

export default XpackSort;
